import {FilePreview} from '@common/file-preview'
import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import tw from 'tailwind-styled-components'
import {FileView, useFileViewerStore} from '../file-viewer-store'
import {ContentTypeIcon} from '../icons/type/content-type-Icon'

const TwContent = tw.div<{$selected: boolean}>`
  box-border
  select-none
  cursor-pointer
  rounded-4
  border-1
  border-solid
  ${p =>
    p.$selected
      ? `
        border-accent-old
        w-56
        h-56
        transition-all
        duration-300
      `
      : `
        hover:border-main-old-dark
        border-transparent
        w-40
        h-40
  `}
`

const TwContentTypeIcon = tw.div`
  flex
  items-center
  justify-center
  h-full
`

export const Preview = observer(
  ({pageNumber, file}: {pageNumber: number; file: FileView}) => {
    const [state, store] = useFileViewerStore()
    const [error, setError] = useState(false)

    const url = FilePreview.getBackgroundPreviewUrl(file?.url)
    const selected = pageNumber === state.currentFileIndex

    const onClick = () => store.setCurrentFileIndex(pageNumber)
    const handleError = () => setError(true)

    const image = (
      <TwContent $selected={selected}>
        <img
          src={url}
          alt=""
          className="object-cover w-full h-full rounded-4"
          onError={handleError}
        />
      </TwContent>
    )
    const other = (
      <TwContent $selected={selected} className="bg-input-old-dark">
        <TwContentTypeIcon>
          <ContentTypeIcon contentType={file.contentType} />
        </TwContentTypeIcon>
      </TwContent>
    )
    if (error) {
      return <div onClick={onClick}>{other}</div>
    }
    return (
      <div onClick={onClick}>
        {file.contentType === 'image' ? image : other}
      </div>
    )
  }
)
